<div class="pg-row">
  <shared-partners></shared-partners>
</div>

<div class="pg-wrapper" *ngIf="(deviceValue | async) === DTypes.Desktop">
  <shared-footer-menu [Device]="DTypes.Desktop"></shared-footer-menu>
</div>
<div class="pg-wrapper">
  <div class="grid align-items-center page-footer__logo"
    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column justify-content-center' : ''}}">

    <div class="col-4 col-sm-12"
      ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'order-1 pt-4 pb-4' : ''}}">

      <div class="grid align-items-center"
        ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'justify-content-center' : 'justify-content-start'}}">
        <div class="col-auto page-footer__social">
          <span class="mr-icon mr-icon-app-ios" (click)="onTeaserIOS()">
            <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span>
            <span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span>
            <span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span>
            <span class="path13"></span><span class="path14"></span><span class="path15"></span><span class="path16"></span>
            <span class="path17"></span><span class="path18"></span><span class="path19"></span>
          </span>
        </div>
        <div class="col-auto page-footer__social">
          <span class="mr-icon mr-icon-app-android" (click)="onTeaserAndroid()">
            <span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span>
            <span class="path5"></span><span class="path6"></span><span class="path7"></span><span class="path8"></span>
            <span class="path9"></span><span class="path10"></span><span class="path11"></span><span class="path12"></span>
            <span class="path13"></span><span class="path14"></span><span class="path15"></span>
          </span>
        </div>
      </div>
    </div>
    <div class="col-4 col-sm-12"
      ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'order-0' : ''}}">
      <a routerLink="/" class="page-footer__link">
        <div class="ui-logo__footer"></div>
      </a>
    </div>
    <div class="col-4 col-sm-12 order-2"
      ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'order-2' : ''}}">

      <div class="grid align-items-center"
        ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'justify-content-center' : 'justify-content-end'}}">
        <!--<div class="col-auto page-footer__social">
          <a href="https://vk.com/musicians_russia" target="_blank" title="ВКонтакте Музыканты России">
            <span class="mr-icon mr-icon-vk">
              <span class="path1"></span><span class="path2"></span>
            </span>
          </a>
        </div>-->
        <!--<div class="col-auto page-footer__social">
          <a href="https://www.facebook.com/rusmuzikant" target="_blank" title="Facebook Музыканты России">
            <span class="mr-icon mr-icon-fb">
              <span class="path1"></span><span class="path2"></span>
            </span>
          </a>
        </div>-->
        <!--<div class="col-auto page-footer__social">
          <a href="https://www.instagram.com/musicians_of_russia/" target="_blank" title="Instagram Музыканты России">
            <span class="mr-icon mr-icon-inst">
              <span class="path1"></span><span class="path2"></span>
              <span class="path3"></span><span class="path4"></span>
            </span>
          </a>
        </div>-->
      </div>
    </div>
  </div>
  <div class="grid align-items-center page-footer__copyright"
    ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'flex-column justify-content-center' : ''}}">
    <div class="col-6 col-sm-12"
      ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'text-center pt-1 pb-1' : ''}}">
      <span>© 2023, MuzRus</span>
    </div>

    <div class="col-6 col-sm-12"
      ngClass="{{(deviceValue | async) === DTypes.Mobile ? 'text-center pt-1 pb-1' : 'text-right'}}">
      <a routerLink="/{{Routing.Pages}}/{{Routing.Confidential}}" class="page-footer__link">
        <span>Политика конфиденциальности</span>
      </a>
    </div>
  </div>
</div>
<div class="partners-slide"></div>
